var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    height: "200px",
    width: "200px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10v3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6v11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3v18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8v7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5v13"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10v3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/mic_off.3635c5b2296f268dedc4f3240d26f20c.svg";
export { ForwardRef as ReactComponent };